/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FleetYards.net API
 * OpenAPI spec version: v1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  unref
} from 'vue';

import type {
  HangarShare,
  StandardError
} from '../../models';

import { axiosClient } from '../../../axiosClient.ts';
import type { ErrorType } from '../../../axiosClient.ts';




/**
 * @summary Create hangar share link
 */
export const createMyHangarShare = (

 signal?: AbortSignal
) => {


      return axiosClient<HangarShare>(
      {url: `/me/hangar/share`, method: 'POST', signal
    },
      );
    }




export const getCreateMyHangarShareMutationKey = () => ['createMyHangarShare'] as const;

export const getCreateMyHangarShareMutationOptions = <TError = ErrorType<StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createMyHangarShare>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createMyHangarShare>>, TError,void, TContext> => {

const mutationKey = getCreateMyHangarShareMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createMyHangarShare>>, void> = () => {


          return  createMyHangarShare()
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateMyHangarShareMutationResult = NonNullable<Awaited<ReturnType<typeof createMyHangarShare>>>

    export type CreateMyHangarShareMutationError = ErrorType<StandardError>


    /**
 * @summary Create hangar share link
 */
export const useCreateMyHangarShare = <TError = ErrorType<StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createMyHangarShare>>, TError,void, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createMyHangarShare>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getCreateMyHangarShareMutationOptions(options), queryClient);
    }
    /**
 * @summary Delete hangar share link
 */
export const destroyMyHangarShare = (

 signal?: AbortSignal
) => {


      return axiosClient<void>(
      {url: `/me/hangar/share`, method: 'DELETE', signal
    },
      );
    }




export const getDestroyMyHangarShareMutationKey = () => ['destroyMyHangarShare'] as const;

export const getDestroyMyHangarShareMutationOptions = <TError = ErrorType<StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyMyHangarShare>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof destroyMyHangarShare>>, TError,void, TContext> => {

const mutationKey = getDestroyMyHangarShareMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof destroyMyHangarShare>>, void> = () => {


          return  destroyMyHangarShare()
        }






  return  { mutationFn, ...mutationOptions }}

    export type DestroyMyHangarShareMutationResult = NonNullable<Awaited<ReturnType<typeof destroyMyHangarShare>>>

    export type DestroyMyHangarShareMutationError = ErrorType<StandardError>


    /**
 * @summary Delete hangar share link
 */
export const useDestroyMyHangarShare = <TError = ErrorType<StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyMyHangarShare>>, TError,void, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof destroyMyHangarShare>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getDestroyMyHangarShareMutationOptions(options), queryClient);
    }
    /**
 * @summary Show hangar share link
 */
export const myHangarShare = (

 signal?: AbortSignal
) => {


      return axiosClient<HangarShare>(
      {url: `/me/hangar/share`, method: 'GET', signal
    },
      );
    }




export const getMyHangarShareQueryKey = () => {
    return [
    'me','hangar','share'
    ] as const;
    }


export const getMyHangarShareQueryOptions = <TData = Awaited<ReturnType<typeof myHangarShare>>, TError = ErrorType<StandardError>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof myHangarShare>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getMyHangarShareQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof myHangarShare>>> = ({ signal }) => myHangarShare(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof myHangarShare>>, TError, TData>
}

export type MyHangarShareQueryResult = NonNullable<Awaited<ReturnType<typeof myHangarShare>>>
export type MyHangarShareQueryError = ErrorType<StandardError>


/**
 * @summary Show hangar share link
 */

export function useMyHangarShare<TData = Awaited<ReturnType<typeof myHangarShare>>, TError = ErrorType<StandardError>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof myHangarShare>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getMyHangarShareQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Rotate hangar share link
 */
export const rotateMyHangarShare = (

 signal?: AbortSignal
) => {


      return axiosClient<HangarShare>(
      {url: `/me/hangar/share/rotate`, method: 'POST', signal
    },
      );
    }




export const getRotateMyHangarShareMutationKey = () => ['rotateMyHangarShare'] as const;

export const getRotateMyHangarShareMutationOptions = <TError = ErrorType<StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof rotateMyHangarShare>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof rotateMyHangarShare>>, TError,void, TContext> => {

const mutationKey = getRotateMyHangarShareMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof rotateMyHangarShare>>, void> = () => {


          return  rotateMyHangarShare()
        }






  return  { mutationFn, ...mutationOptions }}

    export type RotateMyHangarShareMutationResult = NonNullable<Awaited<ReturnType<typeof rotateMyHangarShare>>>

    export type RotateMyHangarShareMutationError = ErrorType<StandardError>


    /**
 * @summary Rotate hangar share link
 */
export const useRotateMyHangarShare = <TError = ErrorType<StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof rotateMyHangarShare>>, TError,void, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof rotateMyHangarShare>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getRotateMyHangarShareMutationOptions(options), queryClient);
    }
